(function () {
  'use strict';

  function initMobileCarousel() {
    if (window.innerWidth >= 750) return;

    var mediaList = document.querySelector('.product__media-list');
    var dotsContainer = document.getElementById('mobile-carousel-dots');

    if (!mediaList || !dotsContainer) return;

    var items = Array.from(mediaList.querySelectorAll('.product__media-item'));
    if (items.length <= 1) {
      dotsContainer.style.display = 'none';
      return;
    }

    // Créer les dots
    dotsContainer.innerHTML = '';
    items.forEach(function (item, index) {
      var dot = document.createElement('button');
      dot.className = 'mobile-carousel-dots__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (index + 1));
      dot.addEventListener('click', function () {
        mediaList.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    });

    var dots = Array.from(dotsContainer.querySelectorAll('.mobile-carousel-dots__dot'));
    var scrollTimeout;

    function updateActiveDot() {
      var scrollLeft = mediaList.scrollLeft;
      var itemWidth = items[0] ? items[0].offsetWidth : 1;
      var activeIndex = Math.round(scrollLeft / itemWidth);
      activeIndex = Math.max(0, Math.min(activeIndex, items.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    mediaList.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    });

    // Réinitialiser lors du changement de variante
    document.addEventListener('variant:changed', function () {
      setTimeout(function () {
        var newItems = Array.from(mediaList.querySelectorAll('.product__media-item'));
        if (newItems.length !== items.length) {
          items = newItems;
          initMobileCarousel();
        } else {
          mediaList.scrollTo({ left: 0, behavior: 'smooth' });
          updateActiveDot();
        }
      }, 300);
    });

    // Écouter slideChanged du thème Dawn
    mediaList.addEventListener('slideChanged', function () {
      setTimeout(updateActiveDot, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileCarousel);
  } else {
    initMobileCarousel();
  }

  // Réinitialiser si la fenêtre est redimensionnée
  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMobileCarousel, 200);
  });
})();
